
const LoginKey = 'tokenVue'

export function getToken() {
  return localStorage.getItem(LoginKey);
}

export function setToken() {
  return localStorage.setItem(LoginKey, "1")
}

export function removeToken() {
  return localStorage.removeItem(LoginKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js